/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { ReferencedOrganisationDTO } from './ReferencedOrganisationDTO';
import {
    ReferencedOrganisationDTOFromJSON,
    ReferencedOrganisationDTOFromJSONTyped,
    ReferencedOrganisationDTOToJSON,
    ReferencedOrganisationDTOToJSONTyped,
} from './ReferencedOrganisationDTO';
import type { EmploymentPeriodDTO } from './EmploymentPeriodDTO';
import {
    EmploymentPeriodDTOFromJSON,
    EmploymentPeriodDTOFromJSONTyped,
    EmploymentPeriodDTOToJSON,
    EmploymentPeriodDTOToJSONTyped,
} from './EmploymentPeriodDTO';

/**
 * 
 * @export
 * @interface PersonToOrganisationDTO
 */
export interface PersonToOrganisationDTO  {
    /**
     * 
     * @type {number}
     * @memberof PersonToOrganisationDTO
     */
    id?: number;
    /**
     * 
     * @type {ReferencedOrganisationDTO}
     * @memberof PersonToOrganisationDTO
     */
    organisation?: ReferencedOrganisationDTO;
    /**
     * 
     * @type {Array<EmploymentPeriodDTO>}
     * @memberof PersonToOrganisationDTO
     */
    employmentPeriods?: Array<EmploymentPeriodDTO>;
}

/**
 * Check if a given object implements the PersonToOrganisationDTO interface.
 */
export function instanceOfPersonToOrganisationDTO(value: object): value is PersonToOrganisationDTO {
    return true;
}

export function PersonToOrganisationDTOFromJSON(json: any): PersonToOrganisationDTO {
    return PersonToOrganisationDTOFromJSONTyped(json, false);
}

export function PersonToOrganisationDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonToOrganisationDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'organisation': json['organisation'] == null ? undefined : ReferencedOrganisationDTOFromJSON(json['organisation']),
              'employmentPeriods': json['employmentPeriods'] == null ? undefined : ((json['employmentPeriods'] as Array<any>).map(EmploymentPeriodDTOFromJSON)),
    };
}

export function PersonToOrganisationDTOToJSON(json: any): PersonToOrganisationDTO {
    return PersonToOrganisationDTOToJSONTyped(json, false);
}

export function PersonToOrganisationDTOToJSONTyped(value?: PersonToOrganisationDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'organisation': ReferencedOrganisationDTOToJSON(value['organisation']),
        'employmentPeriods': value['employmentPeriods'] == null? value['employmentPeriods']: (value['employmentPeriods'] as Array<any>).map(EmploymentPeriodDTOToJSON),
    };
}


